var toSlugCase = require("to-slug-case");
var anglicize = require("anglicize");

module.exports = slug;

function slug (input) {
  return toSlugCase(anglicize(input));
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/to-slug/index.js
 ** module id = 1385
 ** module chunks = 0
 **/